<template>
  <el-dialog
    v-model="dialogVisible"
    destroy-on-close
    :show-close="false"
    :close-on-click-modal="false"
    class="p-8! pt-4! rounded-lg! box-border w-screen"
    :width="width"
    :fullscreen="fullscreen"
    style="
      position: fixed;
      top: 80px;
      left: 266px;
      right: 0;
      bottom: 0;
      margin: 0;
      width: auto;
      display: flex;
      flex-direction: column;
    "
  >
    <template #header>
      <div class="dialog-header text-left pb-4 text-xl flex justify-between relative">
        <div>
          {{ title }}
        </div>
        <!-- <div
          class="text-base text-center text-[var(--el-color-info)] w-8 h-10 -top-1 -right-3 absolute cursor-pointer hover:text-[#2a61ef]"
          @click="() => (fullscreen = !fullscreen)"
        >
          <el-icon><FullScreen /></el-icon>
        </div> -->
        <el-button @click="dialogVisible = false">返回</el-button>
      </div>
    </template>
    <div class="custom-dialog-body">
      <slot></slot>
    </div>
    <template #footer v-if="props.footer">
      <div class="dialog-footer text-center">
        <el-button type="primary" plain @click="dialogVisible = false" class="w-[100px] mr-[60px]"
          >取消</el-button
        >
        <el-button type="primary" @click="save" class="w-[100px]"> 保存 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '标题',
  },
  width: {
    type: String,
    default: '600',
  },
  footer: {
    type: Boolean,
    default: true,
  },
})

const fullscreen = ref(false)
const emit = defineEmits(['update:modelValue', 'submit'])

// 使用计算属性，通过get和set来实现双向绑定
const dialogVisible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const save = () => {
  emit('submit')
}
</script>
<style lang="scss">
.custom-dialog-body {
  height: calc(100vh - 250px);
  overflow: auto;
}
</style>
